import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import { Row, Col } from 'antd';
import styled, { system } from '@xstyled/styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
var StyledRow = styled(Row)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n"])), system);
var StyledCol = styled(Col)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral([""])));
export var RootGridLayout = function RootGridLayout(props) {
  var items = props.items,
      colCount = props.colCount;
  return /*#__PURE__*/_jsx(StyledRow, _objectSpread(_objectSpread({}, props), {}, {
    children: items === null || items === void 0 ? void 0 : items.map(function (item, index) {
      return /*#__PURE__*/_jsx(StyledCol, {
        span: 24 / colCount,
        children: item
      }, index);
    })
  }));
};